module.exports = __webpack_public_path__ + "static/media/icon-piece4-2.52e0b6a7.png";